// Phase P.18 — GDPR — canonical version constants for legal documents.
// Bump `LEGAL_VERSION` when publishing a material change so the cookie banner
// and post-login "please re-accept" modal re-fire for existing users.
//
// Format: YYYY-MM-DD to match the Effective date rendered on each page.
export const LEGAL_VERSION = "2026-07-27";
export const LEGAL_EFFECTIVE_DATE = "27 July 2026";

// Company details — used across Privacy, Terms, Cookies, DPA, Imprint, footer,
// and outbound email footers. Overridable via env for white-label deployments.
export const COMPANY = {
  legal_name: process.env.REACT_APP_LEGAL_NAME || "YourDataApp Ltd",
  trading_name: process.env.REACT_APP_TRADING_NAME || "JobsBook.app",
  address: process.env.REACT_APP_LEGAL_ADDRESS || "Dublin, Ireland",
  contact_email: process.env.REACT_APP_PLATFORM_CONTACT_EMAIL || "info@yourdataapp.com",
  cro_number: process.env.REACT_APP_LEGAL_CRO || "807187",
  vat_number: process.env.REACT_APP_LEGAL_VAT || "4597465SH",
  directors: process.env.REACT_APP_LEGAL_DIRECTORS || "D Sarbul",
  jurisdiction: "Ireland",
  supervisory_authority: "Data Protection Commission (Ireland)",
  supervisory_url: "https://www.dataprotection.ie",
};

// Storage key for cookie consent — includes version so a bump invalidates
// previous consent automatically.
export const COOKIE_CONSENT_KEY = "jbk:cookie-consent";

export function readStoredConsent() {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== LEGAL_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeStoredConsent(payload) {
  try {
    localStorage.setItem(
      COOKIE_CONSENT_KEY,
      JSON.stringify({ version: LEGAL_VERSION, ...payload, timestamp: new Date().toISOString() }),
    );
  } catch { /* localStorage disabled — ignore */ }
}

// Custom event so the "Cookie settings" footer link can re-open the banner
// without holding a global reference to the component.
export const COOKIE_SETTINGS_EVENT = "jbk:open-cookie-settings";
export function openCookieSettings() {
  try { window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT)); } catch { /* SSR guard */ }
}
